import { Chip, Fieldset, Group, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { PaymentMode } from 'src/Services/API/generated';
import { getPaymentModeLabel, USUAL_PAYMENT_MODES } from 'src/Utils/companyContactRoles';

import styles from './PaymentModeSectionForm.module.scss';
import { Props } from './PaymentModeSectionForm.types';

const PaymentModeSectionForm = ({ form, withCustomerReference }: Props) => {
  const { t } = useTranslation();

  return (
    <Fieldset legend={t('contacts.company.payment', 'Règlement')}>
      <div className={styles.content}>
        <div>
          <p className={styles.label}>
            {t('contacts.company.usualPaymentMode', 'Mode de règlement habituel')}
          </p>
          <Chip.Group
            value={form.values.usualPaymentMode ?? ''}
            onChange={value => form.setFieldValue('usualPaymentMode', value as PaymentMode)}
          >
            <Group gap="xs">
              {USUAL_PAYMENT_MODES.map(mode => (
                <Chip
                  key={mode}
                  value={mode}
                  size="md"
                  variant="outline"
                  onClick={() => {
                    // A second tap on the selected chip clears the choice.
                    if (mode === form.values.usualPaymentMode) {
                      form.setFieldValue('usualPaymentMode', undefined);
                    }
                  }}
                >
                  {getPaymentModeLabel(t, mode)}
                </Chip>
              ))}
            </Group>
          </Chip.Group>
        </div>
        {withCustomerReference && (
          <TextInput
            label={t('contacts.company.customerReference', 'N° client / contrat')}
            placeholder={t('contacts.company.customerReferencePlaceholder', 'Ex. 1234 5678 90')}
            {...form.getInputProps('customerReference')}
          />
        )}
      </div>
    </Fieldset>
  );
};

export default PaymentModeSectionForm;
